import type { ButtonHTMLAttributes, AnchorHTMLAttributes, ReactNode } from "react";
import { cn } from "../../lib/utils/format";

type ButtonVariant = "primary" | "secondary" | "ghost" | "danger" | "gold";

interface BaseProps {
  readonly variant?: ButtonVariant;
  readonly size?: "md" | "sm" | "icon";
  readonly children: ReactNode;
  readonly className?: string;
}

type ButtonProps = BaseProps & ButtonHTMLAttributes<HTMLButtonElement>;
type LinkProps = BaseProps & AnchorHTMLAttributes<HTMLAnchorElement> & { readonly href: string };

export function Button({ variant = "secondary", size = "md", className, children, ...props }: ButtonProps) {
  return (
    <button className={cn("button", `button--${variant}`, `button--${size}`, className)} {...props}>
      {children}
    </button>
  );
}

export function LinkButton({ variant = "secondary", size = "md", className, children, ...props }: LinkProps) {
  return (
    <a className={cn("button", `button--${variant}`, `button--${size}`, className)} {...props}>
      {children}
    </a>
  );
}
